module.exports = __webpack_public_path__ + "img/banner8px_cropped_fade.eda6ce0b.png";